/**
 * @prettier
 */
import { MobileAppEvents } from 'src/constants/MobileAppEvents';
import { isMobileApp } from 'src/utils/reactNative/isMobileApp';

export function setSignInCredentialsInMobileApp(username: string, password: string) {
    if (!isMobileApp()) return;
    window.ReactNativeWebView.postMessage(
        JSON.stringify({
            type: MobileAppEvents.SET_SIGN_IN_CREDENTIALS,
            data: {
                username,
                password,
            },
        }),
    );
}
